import React from 'react'
import * as S from './styles'
import { Typography  } from 'antd';

const { Title, Text } = Typography;
const FinishedStep = ({ protocol, HOST}) => {

  const formatPhone = (number) => {
  return number.replace(
    /^(\d{2})(\d{2})(\d{4})(\d{4})$/,
    "+$1 $2 $3-$4"
  );
};

  const linkContato = {
    drogariapacheco: '552140204404',
    drogariasp: '551140033393',
  }

  return (
    <S.Wrapper>
      <S.Title>Fale Conosco:</S.Title>
      <Title level={5}>Solicitação enviada com sucesso!</Title>
      <Text>Recebemos seu contato e o número do seu protocolo é </Text>
      <Text><b>{protocol}</b></Text>
      <br /> {}
      <Text>Por favor, acompanhe nosso retorno através do e-mail que informou no preenchimento do formulário.</Text>
       <br /> {}
      <Text>Para novos contatos conosco, recomendamos que você fale através do nosso WhatsApp, onde conseguimos dar retorno imediato.</Text>
    
      {HOST !== 'dpsp' && 
        <Text>➡️ Segue o link: <a href={`https://wa.me/${linkContato[HOST]}`} target="_blank" rel="noopener noreferrer">{formatPhone(linkContato[HOST])}</a></Text>
      }

      {HOST === 'dpsp' && 
        <>
          <Text>➡️ Drogaria São Paulo: <a href={`https://wa.me/${linkContato.drogariasp}`} target="_blank" rel="noopener noreferrer">{formatPhone(linkContato.drogariasp)}</a></Text>
          <Text>➡️ Drogarias Pacheco: <a href={`https://wa.me/${linkContato.drogariapacheco}`} target="_blank" rel="noopener noreferrer">{formatPhone(linkContato.drogariapacheco)}</a></Text>
        </>
      }

      <br /> {}
      <Text>Agradecemos ao seu contato 😉.</Text>
    </S.Wrapper>
  )
}

export default FinishedStep